import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AccountantExpenseUpdateArea from '../../../components/updateExpense'
import './style.scss'
const UpdateAccountantExpensePage = () => {

    return (
        <Fragment>
            
           <AccountantExpenseUpdateArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default UpdateAccountantExpensePage
/* UpdateAccountantExpensePage */